import enhancedHandler from './enhancedHandler'
import { clearCache, getCacheStats, preloadCriticalData } from './enhancedHandler'

// Export the enhanced handler as default
export default enhancedHandler

// Export utility functions
export { clearCache, getCacheStats, preloadCriticalData }

// Export API modules
export * as userAdmin from './userAdmin'
export * as auth from './auth'
export * as publicApi from './public'
